import React from 'react'
import { Button, TextField } from '@material-ui/core'
import { Pagination } from '@material-ui/lab'

type TablePaginatorProps = {
  totalCount: number | undefined
  limitPerPage: number | undefined
  currentOffset: number | undefined
  onChange(offset: number): void
  disableGoToPage?: boolean
}

export const TablePaginator = (props: TablePaginatorProps) => {
  const { totalCount = 1, limitPerPage = 1, currentOffset = 0, onChange, disableGoToPage } = props

  const currentPage = Math.floor(currentOffset / limitPerPage) + 1
  const totalPages = Math.ceil(totalCount / limitPerPage)

  const [goToValue, setGoToValue] = React.useState(currentPage.toString())

  return (
    <div data-testid={`table-paginator`}>
      {totalPages > 1 && (
        <div className="flex justify-center">
          <div className="flex flex-col gap-4 items-center md:flex-row">
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(e, p) => {
                const newOffset = (p - 1) * limitPerPage
                if (currentOffset.toString() !== newOffset.toString()) onChange(newOffset)
              }}
              showFirstButton
              showLastButton
              siblingCount={1}
              boundaryCount={1}
              shape="rounded"
              color="primary"
            />
            {!disableGoToPage && totalPages > 5 && (
              <div className="flex items-center gap-x-4">
                <span>Page</span>
                <TextField
                  variant="outlined"
                  color="primary"
                  value={goToValue}
                  onFocus={() => setGoToValue('')}
                  onChange={(e) => {
                    setGoToValue(e.target.value)
                  }}
                  InputProps={{
                    margin: 'dense',
                  }}
                  style={{
                    width: '60px',
                  }}
                />
                <span>{`of ${totalPages}`}</span>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    const page = parseInt(goToValue)
                    if (!isNaN(page) && page > 0 && page <= totalPages) {
                      onChange((page - 1) * limitPerPage)
                    }
                  }}
                >
                  Go to Page
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
      {currentPage > 0 && <span className="flex justify-end">{`Page ${currentPage} of ${totalPages}`}</span>}
    </div>
  )
}
